export const ENVIRONMENTS = {
  development: "development",
  staging: "staging",
  production: "production",
  localProduction: "localProduction",
  local: "localBuild",
};

export const LOCAL_STORAGE = {
  accessToken: "access_token",
  fbIdToken: "id_token",
  userId: "user_id",
  recentMobileVerification: "recentMobileVerification",
  permissionRequestAskedInSession: "permissionRequestAskedInSession",
  onboardedUserId: "onBoardedUserId",
  userName: "user_name",
  userEmail: "user_email",

  // sign up save
  firstName: "first_name",
  lastName: "last_name",
  emailAddress: "emailAddress",

  //upsell
  firstUpgradeOfferCode: "firstUpgradeOfferCode",
  secondUpgradeOfferCode: "secondUpgradeOfferCode",
  thirdUpgradeOfferCode: "thirdUpgradeOfferCode",

  //one time power up offer
  oneTimePowerUpOffered: "oneTimePowerUpOffered",

  //fix my membership offer
  fixMyMembershipOffered: "fixMyMembershipOffered",

  //reactivate account offer
  reactivateAccountOffered: "reactivateAccountOffered",

  // app walkthrough
  walkthroughDoneUserId: "walkthroughDoneUserId",

  // game season notifications
  previousSeasonId: "previousSeasonId",
  gameProfileId: "gameProfileId",

  /** User doc id after past-season swipe / nav tutorial on Previous Winners Ladder */
  pastSeasonNavTutorialSeenUserId: "pastSeasonNavTutorialSeenUserId",

  // meta pixel tracking
  metaAppDownloadTracked: "metaAppDownloadTracked",

  // app rate
  appRateLastPromptAttemptMs: "appRateLastPromptAttemptMs",

  // last locker-claim push permission attempt (cooldown for re-prompting)
  lockerPushNotifPromptDismissedAt: "lockerPushNotifPromptDismissedAt",

  // deep link route pending across OTA LiveUpdate.reload()
  pendingDeepLinkPath: "pendingDeepLinkPath",
  /** Completed deeplink path — blocks only the same stale App.getLaunchUrl after OTA restart */
  pendingDeepLinkConsumed: "pendingDeepLinkConsumed",
};

export type FixMembershipModalType = "4th" | "6th" | "last";

export const RESIDENTIAL_STATES = [
  {
    value: "VIC",
    label: "VIC",
  },
  {
    value: "NSW",
    label: "NSW",
  },
  {
    value: "QLD",
    label: "QLD",
  },
  {
    value: "TAS",
    label: "TAS",
  },
  {
    value: "WA",
    label: "WA",
  },
  {
    value: "NT",
    label: "NT",
  },
  {
    value: "SA",
    label: "SA",
  },
  {
    value: "ACT",
    label: "ACT",
  },
];

export const SUBSCRIPTION_TRANSACTION_LABEL = {
  INITIAL_PURCHASE: "Subscription",
  RENEWAL: "Subscription",
  CANCELLATION: "Cancellation",
  PRODUCT_CHANGE: "Update",
  EXPIRATION: "Expiration",
  BILLING_ISSUE: "Billing Issue",
  TRANSFER: "Subscription", // do not show this
};

export const SUBSCRIPTION_STRIPE_TRANSACTION_LABEL = {
  "invoice.paid": "Subscription",
  "customer.subscription.deleted": "Cancellation",
  "invoice.payment_action_required": "Billing Issue",
  "invoice.payment_failed": "Billing Issue",
  "customer.subscription.paused": "Billing Issue",
  "customer.subscription.resumed": "Billing Issue",
};

export type SubSource = "stripe" | "ios" | "android";

export const VIP_IDS = ["prod_P90uZJToKnuMNM", "prod_PAMzgb4vJmu1ND"];
export const LEGEND_IDS = ["prod_Qxk26YL2gXplr0", "prod_QxjMortOKdk8I9"];

export const MOBILE_NATIVE_TEST_ENABLED =
  [
    ENVIRONMENTS.local,
    ENVIRONMENTS.development,
    // ENVIRONMENTS.staging,
    // ENVIRONMENTS.production,
  ].indexOf(import.meta.env.MODE) !== -1;

/** Must match functions/src/config.ts — 403 body when admin OTP session is invalid. */
export const AUTH_SESSION_REVOKED_MESSAGE = "SESSION_REVOKED";
